import React, { useState } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import { FolderAddOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;
const { Option } = Select;

const AddFolderModal = ({ updateParent, parentFolderId = null, folders = [] }) => {
  const { t } = useTranslation("dashboard");
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const handleSubmit = async values => {
    setLoading(true);
    try {
      const payload = {
        name: values.name,
        description: values.description,
        parentFolder: values.parentFolder || parentFolderId
      };

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/folders/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token")
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok) {
        handleCancel();
        if (updateParent) updateParent();
      } else {
        console.error("Error creating folder:", data.errorMessage);
      }
    } catch (error) {
      console.error("Create folder error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" icon={<FolderAddOutlined />} onClick={showModal}>
        {t("New Folder")}
      </Button>

      <Modal
        title={t("Create New Folder")}
        open={visible}
        onCancel={handleCancel}
        width={500}
        footer={
          <>
            <Button onClick={handleCancel}>{t("Cancel")}</Button>
            <Button type="primary" loading={loading} onClick={() => form.submit()}>
              {t("Create Folder")}
            </Button>
          </>
        }
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="name"
            label={t("Folder Name")}
            rules={[
              { required: true, message: t("Please enter folder name") },
              { min: 1, max: 50, message: t("Name must be between 1-50 characters") }
            ]}
          >
            <Input placeholder={t("Enter folder name")} />
          </Form.Item>

          <Form.Item
            name="description"
            label={t("Description")}
            rules={[{ max: 200, message: t("Description must be less than 200 characters") }]}
          >
            <TextArea rows={3} placeholder={t("Enter folder description (optional)")} />
          </Form.Item>

          {!parentFolderId && folders.length > 0 && (
            <Form.Item name="parentFolder" label={t("Parent Folder")}>
              <Select placeholder={t("Select parent folder (optional)")} allowClear>
                {folders.map(folder => (
                  <Option key={folder._id} value={folder._id}>
                    {folder.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default AddFolderModal;
